import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { TeamMembersSection } from "@/components/team-management/TeamMembersSection"

export default function TeamManagement() {
  return (
    <NewAppLayout>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold">
            Team Management
          </h2>
          <p className="text-muted-foreground">
            Manage team members, assign workspaces, and set permissions
          </p>
        </div>

        <TeamMembersSection />
      </div>
    </NewAppLayout>
  )
}
